import React from 'react';
import ArticleLinkCard, { ArticleLinkCardStyle } from '../components/ArticleLinkCard';
import ArticleLinkList from '../models/ArticleLinkList';
import ArticleLinkCardCarousel from '../components/ArticleLinkCardCarousel';
import TitledArticleLinkCardList from '../components/TitledArticleCardList';
import ZonesMap from '@gik/ads/maps/ZonesMap';
import Ad from '@gik/ads/components/Ad';

interface BlogHomePageProps {
  articleLinkLists: ArticleLinkList[];
}

export default class BlogHomePage extends React.PureComponent<BlogHomePageProps> {
  render() {
    return (
      <section className="home-page">
        <div className="bs-padding-wrapper">
          <div className="bs-padding">
            <section className="section-1">
              {this.props.articleLinkLists.length > 0 && (
                <ArticleLinkCardCarousel articleLinks={this.props.articleLinkLists[0].articleLinks.slice(0, 5)} />
              )}
              {this.props.articleLinkLists.length > 1 && (
                <TitledArticleLinkCardList
                  title={this.props.articleLinkLists[1].title}
                  articleLinks={this.props.articleLinkLists[1].articleLinks.slice(0, 3)}
                  style={ArticleLinkCardStyle.smallHorizontal}
                />
              )}
            </section>
            <Ad zone={ZonesMap.BlogZones.Top} mobileZone={ZonesMap.BlogZones.TopMobile} />
            {this.props.articleLinkLists.length > 2 && (
              <section className="section-2">
                <TitledArticleLinkCardList
                  title={this.props.articleLinkLists[2].title}
                  articleLinks={this.props.articleLinkLists[2].articleLinks.slice(0, 4)}
                  style={ArticleLinkCardStyle.small}
                />
              </section>
            )}
            {this.props.articleLinkLists.length > 3 && (
              <section className="section-3">
                <TitledArticleLinkCardList
                  title={this.props.articleLinkLists[3].title}
                  articleLinks={this.props.articleLinkLists[3].articleLinks.slice(0, 2)}
                  style={ArticleLinkCardStyle.featuredHalf}
                />
                <Ad zone={ZonesMap.BlogZones.Middle} mobileZone={ZonesMap.BlogZones.MiddleMobile} />
              </section>
            )}
            {this.props.articleLinkLists.length > 5 && (
              <section className="section-4">
                <TitledArticleLinkCardList
                  title={this.props.articleLinkLists[4].title}
                  articleLinks={this.props.articleLinkLists[4].articleLinks.slice(0, 2)}
                  style={ArticleLinkCardStyle.small}
                />
                <TitledArticleLinkCardList
                  title={this.props.articleLinkLists[5].title}
                  articleLinks={this.props.articleLinkLists[5].articleLinks.slice(0, 2)}
                  style={ArticleLinkCardStyle.small}
                />
              </section>
            )}
            {this.props.articleLinkLists.length > 6 && this.props.articleLinkLists[6].articleLinks.length > 0 && (
              <section className="section-5">
                <ArticleLinkCard
                  articleLink={this.props.articleLinkLists[6].articleLinks[0]}
                  cardStyle={ArticleLinkCardStyle.featured}
                  maxLines={5}
                  headingLevel={2}
                />
                <Ad zone={ZonesMap.BlogZones.Bottom} mobileZone={ZonesMap.BlogZones.BottomMobile} />
              </section>
            )}
          </div>
        </div>
      </section>
    );
  }
}
